/*
 * Example of use: +7 (6--)-xxx-xx-xx
 *  */

export const customAreaCountryCodes = {
  kz: ['7', '6'],
};
